// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1Q0Sz","subheader":"ReorderModal_subheader__xC1Jm","listWrap":"ReorderModal_listWrap__3g5BH"};